import { useContext, useState, useEffect } from "react";
import { Context } from "../context/DataContext";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
// import Button from "@material-ui/core/Button";
// import Menu from "@material-ui/core/Menu";
// import MenuItem from "@material-ui/core/MenuItem";
// import Divider from "@material-ui/core/Divider";
import DatePicker from "@shared/components/DatePicker";
// import XcobrarLoanList from "@shared/components/XcobrarLoanList";
import { printAmount, sortArrayObjs2 } from "@shared/functions";
import { UseCobroList, UseRoute } from "@shared/server/fetcher";
import Loading from "@shared/components/Loading";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
// import { FcEmptyFilter, FcClearFilters } from "react-icons/fc";
// import { AiOutlinePushpin } from "react-icons/ai";
import NoInternetContent from "@shared/components/NoInternetContent";
import Box from "@material-ui/core/Box";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const RenderPresomuestoLoans = ({ week }) => {
  return (
    <Box paddingTop={1}>
      <Card raised>
        <CardContent>
          <div style={{ display: "inline-flex" }} className="mb-2">
            <span className="badge badge-pill badge-dark">
              <Typography variant="body1" component="p" style={{ fontSize: 15 }}>
                <span style={{ padding: 3 }}>{week.elapsed}</span>
              </Typography>
            </span>

            <span className="pl-2">
              <Typography variant="body1">
                <b>
                  Cantidad: {printAmount(week.total.amount)} Monto: {printAmount(week.total.wPayment)}
                </b>
              </Typography>
            </span>
          </div>

          <Typography variant="body1">Lista de Prestamos</Typography>

          <ol style={{ paddingLeft: 20, overflowX: "auto", whiteSpace: "nowrap" }}>
            {week.loans.map((loan, index) => (
              <li className="travelcompany-input" key={index}>
                {printAmount(loan.amount)} Monto {printAmount(loan.wPayment)} {loan.name}
              </li>
            ))}
          </ol>
        </CardContent>
      </Card>
    </Box>
  );
};

const Reports = () => {
  const { state } = useContext(Context);
  const { route: r2, user } = state;

  const [currentDate, setCurrentDate] = useState(null);
  const [filteredLoans, setFilteredLoans] = useState([]);

  const { data: route, isLoading: routeLoading } = UseRoute(r2.creditor_id, user.user_id);

  const d22 =
    route?.collect_week_date === route?.today_date && route?.isCobro === "1"
      ? route?.collect_week_date
      : route?.next_week_date;
  const { data: cobroList, isLoading } = UseCobroList(route?.creditor_id, currentDate ?? d22);

  useEffect(() => {
    if (route) {
      setCurrentDate(d22);
    }
    //eslint-disable-next-line
  }, [route]);

  useEffect(() => {
    if (!cobroList) return;
    let loansResult;

    loansResult = sortArrayObjs2(cobroList.loans, "elapsed", "money_id").reverse();

    setFilteredLoans(loansResult);
  }, [cobroList]);

  if (isLoading || routeLoading) return <Loading />;
  if (!cobroList) return <NoInternetContent />;

  const atrasosSum = cobroList.loans.reduce((acc, obj) => {
    return +obj.statusAmount > 0 ? acc + +obj.statusAmount : acc;
  }, 0);

  const adelantoSum = cobroList.loans.reduce((acc, obj) => {
    return +obj.statusAmount < 0 ? acc + +obj.statusAmount : acc;
  }, 0);

  let revStatus = {};
  const reveredWeeks = [];

  for (var i = 0; i < filteredLoans.length; i++) {
    const { npayments, amount, wPayment, elapsed, name } = filteredLoans[i];

    if (revStatus[elapsed]) {
      revStatus[elapsed].total.amount += amount;
      revStatus[elapsed].total.wPayment += wPayment;
      revStatus[elapsed].loans.push({ amount, wPayment, elapsed, npayments, name });
    } else {
      reveredWeeks.push(elapsed);
      revStatus[elapsed] = {
        elapsed,
        total: { amount, wPayment },
        loans: [{ amount, wPayment, elapsed, npayments, name }],
      };
    }
  }

  return (
    <div className="container mt-3 mb-5">
      {[2272, 2159, 2163].includes(+r2.user_id) && <Link to="/reidy">Reidy Report</Link>}
      <Typography variant="h6" component="h4">
        Estado de la ruta ({cobroList.count}): {printAmount(cobroList.amount)}
      </Typography>

      <Grid container>
        <Grid item xs={7}>
          <DatePicker setCurrentDate={setCurrentDate} date={currentDate} route={route} />
        </Grid>
      </Grid>

      {reveredWeeks.map((week, index) => (
        <RenderPresomuestoLoans key={index} week={revStatus[week]} />
      ))}
    </div>
  );
};

export default Reports;
